export const LOCATION_REDUCER_KEY = 'location';
export interface ILocationState {
    type: string;
}
